import gql from 'graphql-tag'
import { ITEM_FIELDS } from 'src/lib/queries/fields'

export const QUERY_GET_SCHEDULE = gql`
  query getSchedules($userId: Int!) {
  schedules: item(where: {status: {_nin: [ARCHIVED, DELETED]}, item_users: {user_id: { _eq: $userId }}}) {
    id
    startDateTime: start_datetime
    endDateTime: end_datetime
    lessonPlan: item_template_lessonplan {
      id
      subject {
        id
        name
      }
      level {
        id
        name
      }
    }
    originalItem: item {
      id
      lessonPlan: item_template_lessonplan {
        id
        subject {
          id
          name
        }
        level {
          id
          name
        }
      }
    }
  }
}`

export const QUERY_GET_DATA_BASE_ON_LEVEL = gql`
  ${ITEM_FIELDS}
  query getSchedule($levelId: Int!) {
  sections: section(where: {level_id: {_eq: $levelId}}) {
    group {
      id
      name
      userGroups: user_groups {
        user {
          id
          firstName: firstname
          lastName: lastname
          nickName: nickname
          email
          userRoles: user_roles {
            role {
              id
              name
            }
          }
          title
        }
      }
    }
    level {
      id
      name
    }
  }
  originalItems: item(where: {_and: {type: {_eq: LESSONPLAN}, item_template_lessonplan: {level_id: {_eq: $levelId}}}}) {
    ...itemFields
    items(where: {type: {_eq: CONTENT}}) {
      ...itemFields
    }
  }
}`
